<template>
  <div v-if="isInput" class="input-wrapper">
    <el-input
      v-if="!disabled"
      v-model="inputValueTemp"
      :type="dictObject.alias"
      v-bind="elAttrs"
    />
    <div v-else class="disabled-item">
      {{ inputValueTemp || '-' }}
    </div>
  </div>

  <div v-else-if="isUpload" class="input-wrapper">
    <upload
      :props-data="{
        uploadMode: dictObject.alias,
        bizType: 'demand_order_trade',
        attachmentType: attachmentType,
        [`${dictObject.alias}Before`]: inputValueTemp,
        onSuccess: id => (inputValueTemp = id),
        disabled: disabled
      }"
    >
      <div slot="tip" class="important-tip">
        仅可上传单个附件，支持doc/docx/xls/xlsx/ppt/pptx类型文件上传，单个文件最大50MB；其他类型文件单个最大200MB
      </div>
    </upload>
  </div>
</template>

<script>
// 数据字典
import { textInputTypeDict } from '@/dictionary/project/demands'

// 组件
import Upload from '@/components/common/Upload/index'

export default {
  name: 'TextInputType',

  components: {
    Upload
  },

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputType: {
      type: Number,
      default: textInputTypeDict.TEXTAREA.value
    },

    inputValue: {
      type: [Number, String],
      default: ''
    },

    disabled: {
      type: Boolean,
      default: false
    },

    attachmentType: {
      type: String,
      default: 'template_offer_attachment'
    },

    elAttrs: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      // 数据字典
      textInputTypeDict
    }
  },

  computed: {
    // 实现双向绑定
    inputValueTemp: {
      get() {
        return this.inputValue
      },
      set(val) {
        this.$emit('change', val)
      }
    },

    dictObject() {
      return textInputTypeDict.translate(this.inputType)
    },

    isInput() {
      return (
        textInputTypeDict.TEXTAREA.value === this.inputType ||
        textInputTypeDict.TEXT.value === this.inputType
      )
    },
    isUpload() {
      return textInputTypeDict.UPLOAD_FILE_ID.value === this.inputType
    }
  }
}
</script>

<style scoped lang="scss">
.input-wrapper {
  clear: both;
}
.disabled-item {
  padding: 0px 15px;
  min-height: 180px;
  width: 100%;
  box-sizing: border-box;
  font-size: 14px;
  background: $grey-background-color;
  border-radius: 4px;
}
</style>
